var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEditCompratment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1496_7897)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4667 15.2581H5.86659C5.57219 15.2581 5.33325 15.0191 5.33325 14.7247C5.33325 14.4303 5.57219 14.1914 5.86659 14.1914H15.4667C15.7611 14.1914 16 14.4303 16 14.7247C16 15.0191 15.7611 15.2581 15.4667 15.2581Z",
    fill: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.533192 15.2579C0.393086 15.2579 0.257277 15.2032 0.156234 15.1015C0.0253736 14.9706 -0.0278822 14.7822 0.0140454 14.6023L0.789184 11.3133C0.811971 11.2167 0.860929 11.1284 0.931373 11.0588L10.7369 1.25318C11.3401 0.649396 12.3953 0.647964 12.9997 1.25318L14.0053 2.25866C14.3076 2.56088 14.474 2.9627 14.474 3.39005C14.474 3.81753 14.3076 4.22001 14.0053 4.52144L4.19964 14.3264C4.12932 14.3968 4.04104 14.4459 3.94508 14.4686L0.656109 15.2437C0.614963 15.2537 0.573687 15.2579 0.533192 15.2579V15.2579ZM1.79258 11.7052L1.25 14.0077L3.55262 13.4652L13.2508 3.76701C13.3518 3.66597 13.4073 3.53237 13.4073 3.39005C13.4073 3.24786 13.3518 3.11349 13.2508 3.01322L12.2453 2.00696C12.044 1.80566 11.692 1.80566 11.4915 2.00696L1.79258 11.7052ZM3.82203 13.9495H3.82919H3.82203Z",
    fill: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4766 6.82885C11.3402 6.82885 11.2036 6.77689 11.0998 6.67233L8.58521 4.15785C8.37687 3.94952 8.37687 3.61176 8.58521 3.40342C8.79367 3.19495 9.13144 3.19495 9.33977 3.40342L11.8543 5.9179C12.0626 6.12624 12.0626 6.464 11.8543 6.67233C11.7497 6.77689 11.6132 6.82885 11.4766 6.82885V6.82885Z",
    fill: "#AEAEAE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1496_7897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditCompratment);
export default __webpack_public_path__ + "static/media/icon-edit-compratment.f7d542e086e070b837cf08c40c220ca1.svg";
export { ForwardRef as ReactComponent };